//需要过滤掉的组件为：基础组件＋天气、日期组件
export const otherBaseComponentShape = [
  "cxWeather",
  "cxDate",
  "imageComponent",
  "cxHomeLine",
  "cxText",
  "cxEditor",
  "cxShape",
  "cxRadio",
  "cxVideo",
  "cxAudio",
  "cxDigitRoll",
  "cxIcon",
  "cxVerticalLine",
  "cxNoteEditor",
  "cxBreadCrumbs",
  "cxInput",
  "cxCalendar",
  "cxIP",
  "cxSort",
  "cxShare",
  "cxCountdown"
]
export const appWidth = 414 //移动端的宽度
export const appPaddingLeft = 20 //移动端通栏的默认左边距
export const appPaddingRight = 20 //移动端通栏的默认右边距
export const xOtherContentWidth = 80 // 自由布局组件左右边框移动端和pc端默认拖出来的宽度
export const appContentHeadPageLayoutHeight = 54 // 移动端通栏中头部画布默认高度
export const appContentWidth = 414 - appPaddingLeft - appPaddingRight //移动端通栏所能使用的宽度为 移动端的宽度减去通栏两边预留的边距
export const lockHeightComponent = innerElement =>
  typeof ["cxEditor", "cxText", "cxCalendar"].find(it => it === innerElement) === "string"
const keepHeightComponent = innerElement =>
  typeof ["imageComponent", "cxVideo"].find(it => it === innerElement) === "string" //高度不能减小太多的组件
const keepWidthComponent = innerElement =>
  typeof ["cxText", "cxButton", "cxLabel", "cxEditor", "cxMore"].find(it => it === innerElement) === "string" //宽度不能减小太多的组件
export const lockWidthComponent = innerElement =>
  typeof ["cxBreadCrumbs", "cxTabs", "cxEditor", "cxText"].find(it => it === innerElement) === "string"
const threshold = innerElement => {
  //组件大小计算阈值获取方法
  if (keepWidthComponent(innerElement)) {
    return 150
  } else if (innerElement === "cxPagination") {
    return 200
  } else if (innerElement === "cxCalendar") {
    return 375
  } else {
    return 50
  }
}
export class HandleSize {
  constructor(parentW, parentH) {
    this.parentW = parentW
    this.parentH = parentH
  }
  //将新的像素值传入，再将新的像素值还原为原本的单位，主要用于新的值是px，原本的单位为%，这时需要把像素值转化为百分比
  backUnit(opt, num, type) {
    return opt[type + "Type"] === "%" ? (num / (type === "width" ? this.parentW : this.parentH)) * 100 : num
  }
  //获取组件的真实像素大小，例如组件的单位为百分比，此时需要获取它的像素值大小
  getRealSize(opt, type) {
    return Number(
      opt[type + "Type"] === "%" ? (opt[type] / 100) * (type === "width" ? this.parentW : this.parentH) : opt[type]
    )
  }
}
export function isCovered(el1, el2, tools) {
  const el1W = tools.getRealSize(el1, "width")
  const el2W = tools.getRealSize(el2, "width")
  const el1H = tools.getRealSize(el1, "height")
  const el2H = tools.getRealSize(el2, "height")
  let tx1 = parseInt(el1.left)
  let ty1 = parseInt(el1.top)
  let tx2 = tx1 + parseInt(el1W)
  let ty2 = ty1 + parseInt(el1H)
  let mx1 = parseInt(el2.left)
  let my1 = parseInt(el2.top)
  let mx2 = mx1 + parseInt(el2W)
  let my2 = my1 + parseInt(el1H)
  let width = Math.min(tx2, mx2) - Math.max(tx1, mx1)
  let height = Math.min(ty2, my2) - Math.max(ty1, my1)
  let stackArea = (width > 0 ? width : 0) * (height > 0 ? height : 0)
  // stackArea > 0证明发生了覆盖，且需要覆盖高度大于两个组件任意一个的10%才认为是覆盖的
  if (stackArea > 0) {
    const el1First = el1.top < el2.top
    let coveredH = 0
    if (el1First) {
      coveredH = el1.top + el1H - el2.top
    } else {
      coveredH = el2.top + el2H - el1.top
    }

    return coveredH / el1H > 0.1 || coveredH / el2H > 0.1 ? stackArea : false
  }
  return false
}
//组件的宽高可能为百分比 此方法用于还原真实px大小
function isNumber(val) {
  return isNaN(val) === false && val !== null
}
export function checkEleOverflow(ele, tools, newWrapperW, newWrapperH) {
  //组件的左侧超出去
  if (ele.left < 0) ele.left = 0
  //组件的顶部超出去
  if (ele.top < 0) ele.top = 0
  //组件的右侧超出去了
  if (ele.left + tools.getRealSize(ele, "width") > newWrapperW) {
    //组件为宽度锁定组件 需要特殊处理
    if (lockWidthComponent(ele.innerElement)) {
      ele.left = newWrapperW - tools.getRealSize(ele, "width")
      if (tools.getRealSize(ele, "width") > newWrapperW) {
        ele.left = 0
        ele.width = tools.backUnit(ele, newWrapperW, "width")
      }
    } else {
      if (tools.getRealSize(ele, "width") < newWrapperW) {
        const newEleWidth = newWrapperW - ele.left
        //超出的宽度超出了组件本身宽度的30%,就缩减组件的30%宽度，之后再改left
        if (newEleWidth / tools.getRealSize(ele, "width") < 0.5) {
          ele.width = tools.backUnit(ele, tools.getRealSize(ele, "width") * 0.5, "width")
          //此时如果右侧还是超出去了，且组件宽度小于容器宽度，就对left进行处理
          if (ele.left + tools.getRealSize(ele, "width") > newWrapperW) {
            if (tools.getRealSize(ele, "width") <= newWrapperW) {
              ele.left = newWrapperW - tools.getRealSize(ele, "width")
            } else {
              //否则，left为0，组件宽度为容器宽度
              ele.left = 0
              ele.width = tools.backUnit(ele, newWrapperW, "width")
            }
          }
        } else {
          ele.width = tools.backUnit(ele, newWrapperW - ele.left, "width")
        }
      } else {
        //组件宽度大于父容器宽度
        ele.left = 0
        ele.width = tools.backUnit(ele, newWrapperW, "width")
      }
    }
  }
  //组件的底部超出去
  if (ele.top + tools.getRealSize(ele, "height") > newWrapperH) {
    if (tools.getRealSize(ele, "height") < newWrapperH) {
      const newEleWidth = newWrapperH - ele.top
      //超出的宽度超出了组件本身宽度的30%,就缩减组件的30%宽度，之后再改left
      if (newEleWidth / tools.getRealSize(ele, "height") < 0.3) {
        ele.height = tools.backUnit(ele, tools.getRealSize(ele, "height") * 0.7, "height")
        //此时如果右侧还是超出去了，且组件宽度小于容器宽度，就对left进行处理
        if (tools.left + tools.getRealSize(ele, "width") > newWrapperW) {
          if (tools.getRealSize(ele, "height") <= newWrapperH) {
            ele.top = newWrapperH - tools.getRealSize(ele, "height")
          } else {
            //否则，left为0，组件宽度为容器宽度
            ele.top = 0
            ele.height = tools.backUnit(ele, this, newWrapperH, "height")
          }
        }
      } else {
        ele.height = tools.backUnit(ele, newWrapperH - ele.top, "height")
      }
    } else {
      //组件宽度大于父容器宽度
      ele.top = 0
      ele.height = tools.backUnit(ele, newWrapperH, "height")
    }
  }
}

export function getRectPath(pageLayout, rect_id, height) {
  let res = "",
    find = false
  dfs(pageLayout)
  return res
  function dfs(node, path = "") {
    if (find) return
    for (let i = 0; i < node.length; i++) {
      const _path = path.length ? path + "-" + i : String(i)
      if (node[i]?.rectIds?.length && node[i].rectIds.find(it => it === rect_id) !== undefined) {
        find = true
        res = _path
        return
      }

      if (node[i]?.layout?.rows?.length) {
        dfs(node[i].layout.rows, _path + "-rows")
      }
      if (node[i]?.layout?.cols?.length) {
        dfs(node[i].layout.cols, path, _path + "-cols")
      }
    }
  }
}
export function growCurrPageLayoutH(pageLayoutList, rect, growH, newH) {
  if (typeof growH !== "number") return
  const path = getRectPath(pageLayoutList, rect.rect_id).split("-")
  if (path[0].length === 0) {
    return
  }
  const oldH = pageLayoutList[path[0]].layout[path[1]][path[2]].options.height
  pageLayoutList[path[0]].options.height += growH
  pageLayoutList[path[0]].layout[path[1]][path[2]].options.height += growH
  if (newH && typeof newH === "number") {
    pageLayoutList[path[0]].options.height = newH
    pageLayoutList[path[0]].layout[path[1]][path[2]].options.height = newH
  }
  return { oldH, newH: pageLayoutList[path[0]].layout[path[1]][path[2]].options.height }
}
//将组件位置由百分比转为像素值
export function toPxPosition(opt, size) {
  const { boundWidth, boundHeight } = size
  let { left: oldLeft, top: oldTop, leftType, topType, offset, margin, widthType, heightType, width, height, isQuickSite } = opt
  offset = offset ? offset : [0, 0, 0, 0]
  margin = margin ? margin : [0, 0, 0, 0]
  if(isQuickSite){
    return
  }
  const rectW = widthType === "%" ? (width / 100) * boundWidth : width
  const rectH = heightType === "%" ? (height / 100) * boundHeight : height

  if (topType === "%") {
    opt.topType = "px"
    opt.top =
      (Number(oldTop) / 100) * boundHeight -
      (offset[2] - offset[0]) +
      (!isNumber(margin[0]) && margin[0].includes("%") ? Number(margin[0].slice(0, -1) / 100) : margin[0]) * rectH
  }
  if (leftType === "%") {
    opt.leftType = "px"
    opt.left =
      (Number(oldLeft) / 100) * boundWidth -
      (offset[1] - offset[3]) +
      (!isNumber(margin[3]) && margin[3].includes("%") ? Number(margin[3].slice(0, -1) / 100) : margin[3]) * rectW
  }
  opt.offset = null
  opt.margin = null
}
//特殊处理的组件配置项
function handleSpecialComponent(opt, parentW, parentH) {
  //   resetCxTextHeight(opt, parentH) //特殊处理文本组件的高度
  handlePagination(opt) //特殊处理分页组件
}
export const overFlowHiddenEl = innerElement => ["cxText", "cxEditor"].find(it => it === innerElement) //溢出隐藏组件
function handlePagination(opt) {
  if (opt.innerElement === "cxPagination") {
    opt.showTotal = true
    opt.showJumper = false
    opt.showTotal = false
    opt.hideOnSinglePage = true
    opt.maxPageBtnNum = 5
    opt.fontSize = 12
    opt.letterSpacing = 0
    opt.margin = 0
    opt.pageTurnFontSize = 12
    opt.minWidth = 20
    opt.paddingTypeFlag = 1
    opt.padding = 1
    opt.allPaddingTypeFlag = 1
    opt.allPadding = 0
    if (opt.heightType === "%") opt.heightType = "px"
    if (opt.height < 30) opt.height = 30
  }
}
function resetCxTextHeight(opt, wrapperH) {
  if (opt.innerElement !== "cxText") return
  //获取组件真是高度
  const rectHeight = opt.heightType === "%" ? wrapperH * (opt.height / 100) : opt.height
  //获取组件上下边距
  const textPadding = opt.textPaddingTypeFlag === 1 ? opt.padding * 2 : opt.paddingTop + opt.paddingBottom
  const formateHeight = height => (opt.heightType === "%" ? (height / wrapperH) * 100 : height)
  //如果组件的文字无法完全展示
  if (rectHeight < Math.max(opt.lineHeight, opt.fontSize) + textPadding) {
    opt.heightType = "px"
    const newRectH = Math.max(opt.lineHeight, opt.fontSize) + textPadding
    if (newRectH + opt.top > wrapperH) {
      //如果组件高度加上y轴距离大于容器大小，则顶部距离归零
      opt.top = 0
      //如果顶部距离为0时，文字还是无法完全展示，则尝试减小padding
      if (newRectH > wrapperH) {
        //padding为空时，文字能完全展示，则适当减少padding
        if (newRectH - textPadding <= wrapperH) {
          if (opt.textPaddingTypeFlag === 1) {
            opt.padding = wrapperH - newRectH
          } else {
            let count = textPadding
            while (count > 0) {
              if (opt.paddingTop > 0) {
                opt.paddingTop--
                count--
              }
              if (count > 0 && opt.paddingTop > 0) {
                opt.paddingBottom--
                count--
              }
            }
          }
          opt.height = formateHeight(newRectH)
        } else {
          //padding为空时，文字能依旧无法完全展示，先把padding为空，再更改行高和字号
          if (opt.textPaddingTypeFlag === 1) {
            opt.padding = 0
          } else {
            opt.paddingTop = 0
            opt.paddingBottom = 0
          }
          //更改组件高度、行高、字号
          opt.height = wrapperH
          opt.lineHeight = wrapperH
          opt.fontSize = wrapperH
        }
      } else {
        //如果顶部距离为0时，文字可以完全展示，直接更新高度
        opt.height = formateHeight(newRectH)
      }
    } else {
      //如果组件高度加上y轴距离小于等于容器大小时，直接更新高度
      opt.height = formateHeight(newRectH)
    }
  }
}
/**
 * 改变组件的宽度高度,left
 * @param {object} ele 当前组件的options
 * @param {number} oldWrapperW 当前组件在pc端的父容器的宽度
 * @param {number} oldWrapperH 当前组件在pc端的父容器的高度
 * @param {number} currWrapperW 当前组件在移动端的父容器的宽度
 * @param {number} currWrapperH 当前组件在移动端的父容器的高度
 */
export function handleChangeElementInWrapper(ele, oldWrapperW, oldWrapperH, currWrapperW, currWrapperH) {
  //回归原有单位方法
  let oldW = oldWrapperW === undefined ? 1 : oldWrapperW // 兼容传过来的值为undefine情况
  let oldH = oldWrapperH === undefined ? 1 : oldWrapperH
  const tools = new HandleSize(currWrapperW, currWrapperH)
  const { widthType, heightType, width, height, innerElement, left } = ele
  const percentL = left / oldW
  const eleW = widthType === "%" ? (width / 100) * oldW : width
  const eleH = heightType === "%" ? (height / 100) * oldH : height
  const unit = eleW / eleH
  let status = false
  //当组件为某些组件，并且高度占比达到一定程度，就不能缩减太多高不能缩减太多
  const updateH = newH =>
    keepHeightComponent(ele.innerElement) &&
    newH / tools.getRealSize(ele, "height") < 0.7 &&
    tools.getRealSize(ele, "height") > newH
      ? (tools.getRealSize(ele, "width") - newH) / 2 + newH
      : newH
  if (!lockWidthComponent(innerElement) && (ele.widthType !== "%" || ele.innerElement === "cxVideo")) {
    //计算组件宽度
    //m为阈值
    const m = threshold(innerElement)
    if (innerElement === "cxButton" || innerElement === "cxLabel") {
      ele.iconMargin = 0
    }
    if (oldW < m) {
      //pc端父布局的宽度小于阈值时的宽度计算方案
      ele.width = tools.backUnit(ele, (currWrapperW * eleW) / oldW, "width")
      status = true
    } else if (m < eleW && eleW <= oldW) {
      status = true
      //pc端父布局的宽度大于等于阈值时的宽度计算方案
      ele.width = tools.backUnit(ele, ((currWrapperW - m) * (eleW - m)) / (oldW - m) + m, "width")
    }
    if (status && !lockHeightComponent(ele.innerElement)) {
      ele.height = tools.backUnit(ele, updateH(tools.getRealSize(ele, "width") / unit), "height")
    }
  }
  const l = percentL * currWrapperW
  const w = tools.getRealSize(ele, "width")
  ele.left = l + w > currWrapperW ? currWrapperW - w : l
  checkEleOverflow(ele, tools, currWrapperW, currWrapperH)
  //文本组件溢出隐藏
  if (overFlowHiddenEl(ele.innerElement)) {
    ele.textOverFlowType = "hidden"
  }
  //单独处理的组件
  handleSpecialComponent(ele, currWrapperW, currWrapperH)
}
//复制组件的数据相关id
export function copyDataId(org, tar) {
  for (let k in org) {
    if (k.slice(-2).toLowerCase().includes("id")) {
      //新options的所有id值都要与老options相等
      tar[k] = org[k]
    }
  }
}
